import { Card, Number, Text } from "components/common";
import cx from "clsx";
import PropTypes from "prop-types";
import styles from "./index.module.less";

const StatCard = ({ label, value, valueColor, className }) => (
  <Card className={cx(styles.statCard, className)}>
    <Text type="secondary" className={styles.label}>
      {label}
    </Text>
    <div
      className={styles.value}
      style={valueColor ? { color: valueColor } : undefined}
    >
      <Number value={value ?? 0} compact={false} showWholeNumber />
    </div>
  </Card>
);

StatCard.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  valueColor: PropTypes.string,
  className: PropTypes.string,
};

export default StatCard;
